import React, { useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import { useUnit } from "effector-react";
import { getCustomersEffect } from "../../stores/CustomersStore/CustomersStore.effects";
import { CustomersStore } from "../../stores/CustomersStore/CustomersStore";
import AddCustomer from "./components/AddCustomer/AddCustomer";
import CustomerRow from "./components/CustomerRow/CustomerRow";
import { NotFound } from "./CustomersStyles";
import { PageContainer, PageHeader, PageTitle } from "../../components/PageLayout";

const Customers: React.FC = () => {
  const { customers } = useUnit(CustomersStore);
  const loading = useUnit(getCustomersEffect.pending);

  useEffect(() => {
    getCustomersEffect();
  }, []);

  const renderCustomers = () => {
    if (loading && !customers?.length)
      return <tr><NotFound colSpan={4}><CircularProgress size={28} /></NotFound></tr>;

    if (!customers?.length)
      return <tr><NotFound colSpan={4}>Sem clientes para exibir</NotFound></tr>;

    return customers.map((customer) => (
      <CustomerRow key={customer.document} customer={customer} />
    ));
  };

  return (
    <PageContainer style={{ height: "100%", boxSizing: "border-box", overflow: "hidden" }}>
      <PageHeader>
        <PageTitle>Clientes</PageTitle>
        <AddCustomer />
      </PageHeader>
      <TableContainer
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: "auto",
        }}
        component={Paper}
      >
        <Table stickyHeader sx={{ minWidth: 650 }} aria-label="customers table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ whiteSpace: "nowrap" }}>Nome</TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>CNPJ</TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>Saldo</TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }} align="right">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderCustomers()}</TableBody>
        </Table>
      </TableContainer>
    </PageContainer>
  );
};

export default Customers;
